module.exports = __webpack_public_path__ + "img/i_location_input_green.a37c80f4.svg";